<template>
  <div>
    <h1>Scanners</h1>
    <EntityWorking :entity="entity" v-if="entity" />
    <FileWorking :file="file" v-if="file" />
    <ul>
      <li v-for="printer in computedPrinters" :key="printer.id">
        <router-link
          :to="{name:'scanner',params:{id:printer.id}, query:{ objectType:$route.query.objectType, objectId:$route.query.objectId}}"
        >{{printer.code}}</router-link>
        <span>&#160;</span>
        <span>{{printer.name}}</span>
        <span>&#160;</span>
        <span>{{printer.count}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import EntityWorking from "@/components/link/EntityWorking";
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Scanners",
  metaInfo() {
    return {
      title: "Scanners",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityWorking,
    FileWorking
  },
  computed: {
    computedPrinters() {
      return this.printers.map(p => {
        const count = this.counts ? this.counts[p.id] : undefined;
        return { ...p, count };
      });
    }
  },
  data() {
    return { entity: null, file: null, printers: [], counts: null };
  },
  methods: {
    fetchEntity() {
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.$route.query.objectId}`)
        .then(response => {
          // console.log(response.data);
          this.entity = response.data;
        });
    },
    fetchFile() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.query.objectId}`)
        .then(response => {
          // console.log(response.data);
          this.file = response.data;
        });
    },
    fetchPrinters() {
      nbmlaw.get(`/cors/admin/extras/printers`).then(response => {
        // console.log(response.data);
        this.printers = response.data;
      });
    },
    fetchCounts() {
      nbmlaw.get(`/cors/admin/document/scanners/counts`).then(response => {
        // console.log(response.data);
        this.counts = response.data;
      });
    }
  },
  watch: {
    "$route.query.objectId": {
      immediate: true,
      handler() {
        this.entity = null;
        this.file = null;
        if (this.$route.query.objectId) {
          if (this.$route.query.objectType == "entity") {
            this.fetchEntity();
          } else if (this.$route.query.objectType == "file") {
            this.fetchFile();
          }
        }
      }
    }
  },
  created() {
    this.fetchPrinters();
    this.fetchCounts();
  }
};
</script>
